module.exports = __webpack_public_path__ + "img/video.3115fbec.svg";